import { useEffect, useState } from 'react';

import { ChallengeInfo } from '../interfaces/ChallengeInfo';
import { ChallengeInfoService } from '../services/challenge-info/challengeInfoService';

type UseChallengeInfoProps = {
  getChallengeInfo: ChallengeInfoService['getChallengeInfo'];
  challengeId?: number;
};

type UseChallengeInfoReturn = {
  challengeInfo: ChallengeInfo | null;
  isNotFound: boolean;
};

export const useChallengeInfo = ({
  challengeId,
  getChallengeInfo,
}: UseChallengeInfoProps): UseChallengeInfoReturn => {
  const [challengeInfo, setChallengeInfo] = useState<ChallengeInfo | null>(null);
  const [isNotFound, setIsNotFound] = useState(false);

  const getChallengeInfoData = async () => {
    if (!challengeId) {
      return;
    }

    try {
      const response = await getChallengeInfo(challengeId, {
        ignoreErrorCodes: [404],
      });
      setChallengeInfo(response);
    } catch (error: any) {
      if (error.response?.status === 404) {
        setIsNotFound(true);
      }
    }
  };

  useEffect(() => {
    getChallengeInfoData();
  }, [challengeId]);

  return { challengeInfo, isNotFound };
};
